var map = {
	"./de/general7/slide1.svg": 515820,
	"./en/general7/slide1.svg": 210112,
	"./es/general7/slide1.svg": 49129,
	"./fr/general7/slide1.svg": 189473,
	"./nl/general7/slide1.svg": 959703,
	"./pt/general7/slide1.svg": 244501
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 177538;